import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../store';
import DropboxDialog from './Dialog';
import './styles.scss';

export default function showDropboxChooser(props) {
  const $wrapper = document.createElement('div');
  $wrapper.classList.add('wrapperDialog');
  $wrapper.classList.add('wrapperDropboxChooserDialog');
  document.body.appendChild($wrapper);

  function destroy() {
    ReactDOM.unmountComponentAtNode($wrapper);
    document.body.removeChild($wrapper);
  }

  ReactDOM.render(
    <Provider store={store}>
      <DropboxDialog destroy={destroy} {...props} />
    </Provider>, $wrapper,
  );
}
